/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Sent_Reset_LinkInputs */



/**
* | output |
* | --- |
* | "We sent a password reset link to" |
*
* @param {Login_Sent_Reset_LinkInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_sent_reset_link = /** @type {((inputs?: Login_Sent_Reset_LinkInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Sent_Reset_LinkInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous avons envoyé un lien de réinitialisation à")
	if (locale === "es") return /** @type {LocalizedString} */ ("Hemos enviado un enlace de recuperación a")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Enviamos um link de redefinição de senha para")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abbiamo inviato un link per reimpostare la password a")
	return /** @type {LocalizedString} */ ("We sent a password reset link to")
});